"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[795],{

/***/ 6675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ isObjectNotEmpty; },
/* harmony export */   "xE": function() { return /* binding */ getFullDate; }
/* harmony export */ });
/* unused harmony exports renderTheMetaTags, handleImageLink */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var renderTheMetaTags = function renderTheMetaTags(metaData) {
  return metaData === null || metaData === void 0 ? void 0 : metaData.map(function (singleMeta) {
    if (!singleMeta.name || !singleMeta.content) return;
    return /*#__PURE__*/_jsx(NextSeo, {
      title: singleMeta === null || singleMeta === void 0 ? void 0 : singleMeta.name,
      description: singleMeta === null || singleMeta === void 0 ? void 0 : singleMeta.content
    }, singleMeta === null || singleMeta === void 0 ? void 0 : singleMeta.id);
  });
};
var isObjectNotEmpty = function isObjectNotEmpty(obj) {
  return obj && Object.keys(obj).length !== 0;
};
var getFullDate = function getFullDate(date, locale) {
  if (!date) return;
  var formattedLocale = locale === "ar" ? "ar-EG" : "en-US";
  return new Date(date).toLocaleDateString(formattedLocale, {
    month: "long",
    day: "numeric",
    year: "numeric"
  });
};
var handleImageLink = function handleImageLink(image) {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    // eslint-disable-next-line no-undef
    return "".concat("https://mu7.ejjadh.info", "/storage/uploads/").concat(image);
  }
};

/***/ }),

/***/ 795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_helpers_functions_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6675);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);






var PageHeader = next_dynamic_js__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(1608), __webpack_require__.e(1664), __webpack_require__.e(9477), __webpack_require__.e(4208), __webpack_require__.e(6857)]).then(__webpack_require__.bind(__webpack_require__, 2094));
});
var BreadCrumb = next_dynamic_js__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(4346)]).then(__webpack_require__.bind(__webpack_require__, 4346));
});
var BlogDetails = next_dynamic_js__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(1664), __webpack_require__.e(9563)]).then(__webpack_require__.bind(__webpack_require__, 9563));
});
var Footer = next_dynamic_js__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(1608), __webpack_require__.e(1664), __webpack_require__.e(7148), __webpack_require__.e(169)]).then(__webpack_require__.bind(__webpack_require__, 7148));
});

var SingleBlog = function SingleBlog(_ref) {
  var _singleBlogData$title, _singleBlogData$title2, _singleBlogData$title3;

  var data = _ref.data;
  var singleBlogData = data.singleBlogData;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      locale = _useRouter.locale;

  var renderSingleBlog = function renderSingleBlog() {
    if (singleBlogData && (0,src_helpers_functions_js__WEBPACK_IMPORTED_MODULE_3__/* .isObjectNotEmpty */ .Pk)(singleBlogData)) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(BlogDetails, {
        singleBlogData: singleBlogData
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PageHeader, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(BreadCrumb, {
      title: (singleBlogData === null || singleBlogData === void 0 ? void 0 : (_singleBlogData$title = singleBlogData.title) === null || _singleBlogData$title === void 0 ? void 0 : _singleBlogData$title[locale].length) > 100 ? "".concat(singleBlogData === null || singleBlogData === void 0 ? void 0 : (_singleBlogData$title2 = singleBlogData.title) === null || _singleBlogData$title2 === void 0 ? void 0 : _singleBlogData$title2[locale].slice(0, 100), "...") : "".concat(singleBlogData === null || singleBlogData === void 0 ? void 0 : (_singleBlogData$title3 = singleBlogData.title) === null || _singleBlogData$title3 === void 0 ? void 0 : _singleBlogData$title3[locale].slice(0, 100))
    }), renderSingleBlog(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Footer, {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SingleBlog);

/***/ })

}]);